import { render, staticRenderFns } from "./FormFieldSetBordered.vue?vue&type=template&id=33c084f0&scoped=true&"
import script from "./FormFieldSetBordered.vue?vue&type=script&lang=js&"
export * from "./FormFieldSetBordered.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldSetBordered.vue?vue&type=style&index=0&id=33c084f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c084f0",
  null
  
)

export default component.exports